module.exports = __webpack_public_path__ + "static/assets/e5b154204e52abcd98aab010699d4fce.png";